import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import NodeEquipmentPage from './Page';
import type { NodeEquipment } from '../../../types/uncinc_profile/nodes';

type EquipmentViewmode = 'teaser' | 'page';

interface EquipmentProps {
  entity: ImmutableEntity<NodeEquipment>;
  viewMode: EquipmentViewmode;
}

const NodeEquipmentsWrapper: React.FC<EquipmentProps> = ({ entity, viewMode, ...props }) => {
  switch (viewMode) {
    case 'page':
    default:
      return <NodeEquipmentPage entity={entity} {...props} />;
  }
};

export default NodeEquipmentsWrapper;
